// @flow @format
import {combineReducers} from 'redux';
import entities, {initialState as entitiesInitialState} from './entities';
import history, {initialState as historyInitialState} from './history';
import session, {
	CLOSE_SESSION,
	initialState as sessionInitialState,
} from './session';
import selection, {initialState as selectionInitialState} from './selection';

import type {State as HistoryState} from './history';
import type {State as SessionState} from './session';
import type {State as EntitiesState} from './entities';
import type {State as SelectionState} from './selection';

export type State = {
	+session: SessionState,
	+entities: EntitiesState,
	+history: HistoryState,
	+selection: SelectionState,
};

const reducers = combineReducers({
	session,
	history,
	entities,
	selection,
});

// StoreState is the type that defines the initial store state. Is used to
// get compatibility with the definition of redux.createStore which needs
// that the reducers state argument match the preleadedState type.
export type StoreState = {
	session?: SessionState,
	entities?: EntitiesState,
	history?: HistoryState,
	selection?: SelectionState,
};

type Action = {
	+type: string,
};

export default (state: StoreState, action: Action) => {
	if (action.type === CLOSE_SESSION) {
		return {
			selection: selectionInitialState,
			session: sessionInitialState,
			history: historyInitialState,
			entities: entitiesInitialState,
		};
	}
	return reducers(state, action);
};



// WEBPACK FOOTER //
// ./src/reducers/index.js